//Angular
import { NgModule } from "@angular/core";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";
import { LoadingSpinnerModalComponent } from "./loading-spinner-modal/loading-spinner-modal.component";

//Externos

//Componentes

@NgModule({
  declarations: [LoadingSpinnerComponent, LoadingSpinnerModalComponent],
  exports: [LoadingSpinnerComponent, LoadingSpinnerModalComponent],
  imports: [],
})
export class LoadingSpinnerModule {}
